import { ReactElement } from 'react';
import Tooltip from '../../../components/Tooltip';

export type SegmentMode = 'segment' | 'all';

/**
 * Radio pair to scope a histogram to the run's test segments (active laps /
 * traverses, per-sample Gate_NG10 > 0) or the whole run. 'Test Segment' is
 * disabled when the run has no active segments.
 */
function SegmentModeSelector(props: {
  name: string;
  mode: SegmentMode;
  setMode: (mode: SegmentMode) => void;
  segmentAvailable: boolean;
}): ReactElement {
  const { name, mode, setMode, segmentAvailable } = props;

  const options: { value: SegmentMode; label: string; disabled: boolean; tooltip: string }[] = [
    {
      value: 'segment',
      label: 'Test Segment',
      disabled: !segmentAvailable,
      tooltip: segmentAvailable
        ? 'Only samples inside active laps / traverses'
        : 'This run has no active laps or traverses',
    },
    {
      value: 'all',
      label: 'All',
      disabled: false,
      tooltip: 'All samples in the run',
    },
  ];

  return (
    <div className="cr-flex cr-flex-row cr-items-center cr-gap-4">
      {options.map((option) => (
        <Tooltip key={option.value} title={option.tooltip} placement="top">
          <label
            className={
              option.disabled
                ? 'cr-flex cr-cursor-not-allowed cr-items-center cr-gap-1 cr-text-sm cr-text-gray-400'
                : 'cr-flex cr-cursor-pointer cr-items-center cr-gap-1 cr-text-sm'
            }
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={mode === option.value}
              disabled={option.disabled}
              onChange={() => setMode(option.value)}
            />
            {option.label}
          </label>
        </Tooltip>
      ))}
    </div>
  );
}

export default SegmentModeSelector;
